import type { UIMessage } from "ai";

const MAX_QUERY_CHARS = 60;
const THINKING = "Thinking";

const LABELS: Record<string, string> = {
	getOutline: "Looking through the outline",
	readSection: "Reading the material",
	getRelated: "Looking for related content",
	getConcept: "Looking up a concept",
};

const searchLabel = (input: unknown): string => {
	const query =
		typeof (input as { query?: unknown } | undefined)?.query === "string"
			? (input as { query: string }).query.trim()
			: "";

	if (query === "") return "Searching the library";

	return `Searching the library for "${query.slice(0, MAX_QUERY_CHARS).trimEnd()}"`;
};

/**
 * A short line saying what the Tutor is doing while the user waits, from the latest tool call: a search names its query, and the other tools say only the kind of thing they do (their inputs are ids). The line stays on the latest call after it finishes, while the model reads the result, until the next call replaces it. Before any call it says "Thinking". Nothing when the latest part is text, the quiz tool's own card, or a tool it does not know, so the chat falls back to the plain typing dots
 * @param {UIMessage[]} messages - The conversation so far
 * @returns {string | null} The line to show, or null
 */
const describeToolActivity = (messages: UIMessage[]): string | null => {
	const last = messages[messages.length - 1];

	if (!last || last.role !== "assistant") return THINKING;

	const parts = last.parts.filter((part) => part.type !== "step-start");
	const part = parts[parts.length - 1] as
		| { type: string; input?: unknown }
		| undefined;

	if (!part) return THINKING;

	if (!part.type.startsWith("tool-")) return null;

	const name = part.type.slice("tool-".length);

	return name === "searchKnowledge"
		? searchLabel(part.input)
		: (LABELS[name] ?? null);
};

export default describeToolActivity;
